/* Types */
import { DeliveryAddress } from '@/types/api/api-v3/addresses'

const joinPartsOfAddress = (array: string[], separator = ', '): string =>
  array.filter((n) => n).join(separator)

/**
 * Формируем поля адреса доставки в строку полного адреса
 * @param address - адрес
 */
export const formatToAddressDelivery = (address: DeliveryAddress): string => {
  const province = address.province || ''
  const locality = address.locality || ''
  const district = address.district || ''
  const street = address.street || ''
  const house = address.house || ''

  return joinPartsOfAddress([locality, district, street, house]) || province
}
